import dynamic from 'next/dynamic'
import Head from 'next/head'
import React, { FC, useEffect, useState } from 'react'

import BlogPostContainer from '../../components/blog-post/BlogPostContainer/BlogPostContainer'
import CommonPageLight from '../../components/layout/CommonPage/CommonPageLight'
import useRootSizes from '../../hooks/useRootSizes'
import { BlogPostConfig, GhostPost } from '../../utils/types'

const DynamicPreviewPlayer = dynamic(() => import('../../components/common/PreviewPlayer/PreviewPlayer'))

export type BlogPageProps = {
  post: GhostPost
  postConfig: BlogPostConfig
}

const BlogPage: FC<BlogPageProps> = ({ post, postConfig }) => {
  const { isMobile, isTablet } = useRootSizes()

  const [scrollPos, setScrollPos] = useState<number>(0)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setMounted(true)
    }, 500)
  }, [])

  const handleScroll = (e: any) => {
    setScrollPos(e.currentTarget.scrollTop)
  }
  const url = 'https://chordchord.com/' + post.slug

  return (
    <>
      <Head>
        <title>{post.meta_title}</title>
        <meta name='description' content={post.meta_description || ''} />
        <meta property='og:url' content={url} />
        <meta property='og:type' content='article' />
        <meta property='og:title' content={post.og_title || ''} />
        <meta property='og:image' content={post.og_image || ''} />
        <meta property='og:description' content={post.og_description || post.meta_description || ''} />
        <meta property='article:published_time' content={post.published_at || ''} />
        <meta property='og:updated_time' content={post.updated_at || ''} />
        {post.canonical_url && post.canonical_url !== '' && <link rel='canonical' href={post.canonical_url} />}
      </Head>
      <CommonPageLight
        scrollable={!isMobile}
        headerColor={post.type === 'guide-post' ? '#17171A' : undefined}
        handleScroll={isMobile ? undefined : handleScroll}
        scrolled={!isTablet && mounted}
        mode={post.type === 'guide-post' ? 'GUIDE' : undefined}
      >
        <DynamicPreviewPlayer />

        <BlogPostContainer post={post} scrollPos={scrollPos} postConfig={postConfig} />

        {/* <HotjarScript distinctId={distinctId} /> */}
      </CommonPageLight>
    </>
  )
}

export default BlogPage
